import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const THERAPY_VENDOR_FIELDS = [
  {
    question: VENDORS.REHAB_VENDOR,
    title: 'Rehab vendor',
    invoiceFileTypeId: FILE_TYPES.REHAB_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.REHAB_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EQUIPMENT_LEASE_VENDOR,
    title: 'Equipment lease',
    invoiceFileTypeId: FILE_TYPES.EQUIPMENT_LEASE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EQUIPMENT_LEASE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EQUIPMENT_RENTALS_VENDOR,
    title: 'Equipment rentals',
    invoiceFileTypeId: FILE_TYPES.EQUIPMENT_RENTALS_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EQUIPMENT_RENTALS_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.THERAPY_OUTSOURCED_COMPANY,
    title: 'Therapy outsourced company',
    invoiceFileTypeId: FILE_TYPES.THERAPY_OUTSOURCED_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.THERAPY_OUTSOURCED_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.THERAPY_STAFFING_AGENCY,
    title: 'Therapy staffing agency',
    invoiceFileTypeId: FILE_TYPES.THERAPY_STAFFING_AGENCY_INVOICE,
    contractFileTypeId: FILE_TYPES.THERAPY_STAFFING_AGENCY_CONTRACT,
  },
  {
    question: VENDORS.THERAPY_SUPPLIES_PROVIDER,
    title: 'Therapy supplies provider',
    invoiceFileTypeId: FILE_TYPES.THERAPY_SUPPLIES_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.THERAPY_SUPPLIES_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.THERAPY_SOFTWARE_VENDOR,
    title: 'Therapy software',
    invoiceFileTypeId: FILE_TYPES.THERAPY_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.THERAPY_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.THERAPY_MANAGEMENT_COMPANY,
    title: 'Therapy management company',
    invoiceFileTypeId: FILE_TYPES.THERAPY_MANAGEMENT_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.THERAPY_MANAGEMENT_COMPANY_CONTRACT,
  },
];
